import { deleteMultiSelectedComps } from "../../Pages/multiCompSelect";

export const useEditorDeleteFlows = ({
  playPauseRef,
  selectedComponent,
  refMultiselected,
  editComponentRef,
  refClaimsArray,
  refDroppedComponentIds,
  refDroppedTextIdsArray,
  refClaimReferencesFootnotes,
  setDroppedTitleIds,
  setOpenTimelinePopup,
  tempLayer,
  setLayerCompData,
  setMultiSelectedComps,
  animationObjRef,
  setAnimationObject,
  setSeconds,
  setMillSeconds,
  setSelectedComponent,
  setVisibility,
  setClaimsArray,
  setClaimReferencesFoonotes,
  setDroppedComponentIds,
  setDroppedTextIds,
  editComponent,
  refReusableTextIdsArray,
  setReusableTextIdsArray,
  refDroppedComponentTextIds,
  layerCompData,
  setScrollbarItems,
  setContextMenuvisibility,
  refScrollClaimReferencesFootnotes,
  setScrollClaimReferencesFoonotes,
  tempSelect,
  tempLayerScrollbarItems,
}) => {
  const deleteClaimsIdsOfScrollbarComp = (scrollbarComps) => {
    let tempClaimsArray = [...refClaimsArray.current];
    let tempReusableTextArray = [...refReusableTextIdsArray.current];
    const claimIdsToRemove = scrollbarComps
      .filter((comp) => comp.claimId)
      .map((comp) => comp.claimId);

    const reusableTextIdsToRemove = scrollbarComps
      .filter((comp) => comp.reusableTextId)
      .map((comp) => comp.reusableTextId);

    tempClaimsArray = tempClaimsArray.filter(
      (id) => !claimIdsToRemove.includes(id),
    );
    setClaimsArray(tempClaimsArray);

    tempReusableTextArray = tempReusableTextArray.filter(
      (id) => !reusableTextIdsToRemove.includes(id),
    );
    setReusableTextIdsArray(tempReusableTextArray);
  };

  const deleteComponentOnCanvas = (event) => {
    if (
      !playPauseRef.current.animationCompleted ||
      selectedComponent?.componentStyles?.lockBoolean
    )
      return;
    if (refMultiselected.current.length > 1 && !editComponentRef.current) {
      const claimArray = [...refClaimsArray.current];
      const compArray = [...refDroppedComponentIds.current];
      const matchTextArray = [...refDroppedTextIdsArray.current];
      const referenceFootnoteObj = refClaimReferencesFootnotes.current;
      const titleIdsToRemove = refMultiselected.current
        .filter((comp) => comp.titleId)
        .map((comp) => comp.titleId);
      if (titleIdsToRemove.length > 0) {
        setDroppedTitleIds((prev) =>
          prev.filter((id) => !titleIdsToRemove.includes(id)),
        );
      }

      deleteMultiSelectedComps(
        event,
        setOpenTimelinePopup,
        [...tempLayer.current],
        setLayerCompData,
        [...refMultiselected.current],
        setMultiSelectedComps,
        { ...animationObjRef.current },
        setAnimationObject,
        setSeconds,
        setMillSeconds,
        setSelectedComponent,
        setVisibility,
        claimArray,
        referenceFootnoteObj,
        setClaimsArray,
        setClaimReferencesFoonotes,
        compArray,
        matchTextArray,
        setDroppedComponentIds,
        setDroppedTextIds,
      );
    } else {
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
      const tempArray = [...tempLayer.current];
      let tempScrollbarComponents = tempArray.find(
        (component) => component?.id === editComponent?.id,
      )?.scrollbarComponents;
      let data = [
        ...(editComponentRef.current ? tempScrollbarComponents : tempLayer.current),
      ];
      let selectCompObj = { ...tempSelect.current };
      if (selectCompObj.componentType === "Scrollbar") {
        deleteClaimsIdsOfScrollbarComp(selectCompObj.scrollbarComponents);
      }
      if (selectCompObj.titleId && !editComponentRef.current) {
        setDroppedTitleIds((prev) =>
          prev.filter((id) => id !== selectCompObj.titleId),
        );
      }

      if (selectCompObj.claimId && !editComponentRef.current) {
        const tempClaims = [...refClaimsArray.current];

        let footnotes = refClaimReferencesFootnotes.current.footnotes;
        let references = refClaimReferencesFootnotes.current.references;
        let abbreviation = refClaimReferencesFootnotes.current.abbreviation;
        const updatedFootnotes = footnotes?.filter(
          (claim) => claim.claimId !== selectCompObj.claimId,
        );
        const updatedReferences = references?.filter(
          (claim) => claim.claimId !== selectCompObj.claimId,
        );
        const updatedAbbreviation = abbreviation?.filter(
          (claim) => claim.claimId !== selectCompObj.claimId,
        );
        setClaimsArray(
          tempClaims.filter((claimId) => claimId !== selectCompObj.claimId),
        );
        setClaimReferencesFoonotes({
          footnotes: updatedFootnotes,
          references: updatedReferences,
          abbreviation: updatedAbbreviation,
        });
      }
      if (selectCompObj.reusableTextId && !editComponentRef.current) {
        const tempRtIdsArray = [...refReusableTextIdsArray.current];
        setReusableTextIdsArray(
          tempRtIdsArray.filter((rtId) => rtId !== selectCompObj.reusableTextId),
        );
      }
      if (selectCompObj.matchTextId && !editComponentRef.current) {
        const tempMatchTexts = [...refDroppedTextIdsArray.current];
        let footnotes = refClaimReferencesFootnotes.current.footnotes;
        let references = refClaimReferencesFootnotes.current.references;
        let abbreviation = refClaimReferencesFootnotes.current.abbreviation;

        const updatedMatchFootnotes = footnotes?.filter(
          (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
        );

        const updatedMatchReferences = references?.filter(
          (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
        );
        const updatedMatchAbbreviation = abbreviation?.filter(
          (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
        );
        setDroppedTextIds(
          tempMatchTexts.filter(
            (matchTextId) => matchTextId !== selectCompObj.matchTextId,
          ),
        );
        setClaimReferencesFoonotes({
          footnotes: updatedMatchFootnotes,
          references: updatedMatchReferences,
          abbreviation: updatedMatchAbbreviation,
        });
      }

      const deletedId = selectCompObj.id;

      if (
        selectCompObj.id &&
        !editComponentRef.current &&
        !selectCompObj.matchTextId &&
        !selectCompObj.claimId
      ) {
        const updatedComponentIds = refDroppedComponentIds.current.filter(
          (compId) => compId !== deletedId,
        );
        refDroppedComponentIds.current = updatedComponentIds;
        setDroppedComponentIds(updatedComponentIds);

        const relatedComponentTextItems =
          refDroppedComponentTextIds.current.filter((item) => item.id === deletedId);

        const matchTextIdsToRemove = relatedComponentTextItems.map(
          (item) => item.matchTextId,
        );

        const updatedDroppedTextIds = refDroppedTextIdsArray.current.filter(
          (textId) => !matchTextIdsToRemove.includes(textId),
        );

        refDroppedTextIdsArray.current = updatedDroppedTextIds;
        setDroppedTextIds(updatedDroppedTextIds);

        const updatedFootnotes =
          refClaimReferencesFootnotes.current.footnotes?.filter(
            (item) => item.id !== deletedId,
          ) || [];

        const updatedReferences =
          refClaimReferencesFootnotes.current.references?.filter(
            (item) => item.id !== deletedId,
          ) || [];

        const updatedAbbreviation =
          refClaimReferencesFootnotes.current.abbreviation?.filter(
            (item) => item.id !== deletedId,
          ) || [];

        setClaimReferencesFoonotes({
          footnotes: updatedFootnotes,
          references: updatedReferences,
          abbreviation: updatedAbbreviation,
        });
      }

      setMultiSelectedComps([]);

      if (data && selectCompObj) {
        let filteredComponents;

        if (selectCompObj.matchTextId && !editComponentRef.current) {
          filteredComponents = data.filter((item) => item.id !== deletedId);
        } else {
          filteredComponents = data.filter((item) => item.id !== deletedId);
        }

        if (event !== "fromKey" && Object.values(animationObjRef.current).length > 0) {
          let tempAnimationObj = {};
          for (const props in animationObjRef.current) {
            if (props !== selectCompObj.id)
              tempAnimationObj[props] = animationObjRef.current[props];
          }
          setAnimationObject(tempAnimationObj);
        }
        if (layerCompData.length === 1) {
          setMillSeconds(0);
          setSeconds(0);
        }
        setSelectedComponent("compdeleted");
        if (editComponentRef.current) {
          if (selectCompObj.titleId) {
            setDroppedTitleIds((prev) =>
              prev.filter((id) => id !== selectCompObj.titleId),
            );
          }
          setScrollbarItems(filteredComponents);
        } else {
          setLayerCompData(filteredComponents);
        }
        setVisibility(false);
        setContextMenuvisibility(false);
      }
    }
  };

  const handleDeleteKeyScrollbarComponent = (event) => {
    let selectCompObj = { ...tempSelect.current };
    if (selectCompObj.claimId && editComponentRef.current) {
      const tempClaims = [...refClaimsArray.current];
      let footnotes = refScrollClaimReferencesFootnotes.current.footnotes;
      let references = refScrollClaimReferencesFootnotes.current.references;
      let abbreviation = refScrollClaimReferencesFootnotes.current.abbreviation;
      const updatedFootnotes = footnotes.filter(
        (claim) => claim.claimId !== selectCompObj.claimId,
      );
      const updatedReferences = references.filter(
        (claim) => claim.claimId !== selectCompObj.claimId,
      );
      const updatedAbbreviation = abbreviation.filter(
        (claim) => claim.claimId !== selectCompObj.claimId,
      );
      setClaimsArray(
        tempClaims.filter((claimId) => claimId !== selectCompObj.claimId),
      );
      if (event === "Delete") {
        setScrollClaimReferencesFoonotes({
          footnotes: updatedFootnotes,
          references: updatedReferences,
          abbreviation: updatedAbbreviation,
        });
      } else {
        setTimeout(() => {
          setScrollClaimReferencesFoonotes({
            footnotes: updatedFootnotes,
            references: updatedReferences,
            abbreviation: updatedAbbreviation,
          });
        }, 500);
      }
    } else if (
      selectCompObj.id &&
      editComponentRef.current &&
      !selectCompObj.matchTextId
    ) {
      const deletedId = selectCompObj.id;
      const updatedComponentIds = refDroppedComponentIds.current.filter(
        (compId) => compId !== deletedId,
      );
      refDroppedComponentIds.current = updatedComponentIds;
      const relatedComponentTextItems =
        refDroppedComponentTextIds.current.filter((item) => item.id === deletedId);

      const matchTextIdsToRemove = relatedComponentTextItems.map(
        (item) => item.matchTextId,
      );

      const updatedDroppedTextIds = refDroppedTextIdsArray.current.filter(
        (textId) => !matchTextIdsToRemove.includes(textId),
      );

      refDroppedTextIdsArray.current = updatedDroppedTextIds;

      const updatedFootnotes =
        refScrollClaimReferencesFootnotes.current.footnotes?.filter(
          (item) => item.id !== deletedId,
        ) || [];

      const updatedReferences =
        refScrollClaimReferencesFootnotes.current.references?.filter(
          (item) => item.id !== deletedId,
        ) || [];

      const updatedAbbreviation =
        refScrollClaimReferencesFootnotes.current.abbreviation?.filter(
          (item) => item.id !== deletedId,
        ) || [];

      if (event === "Delete") {
        setDroppedComponentIds(updatedComponentIds);
        setDroppedTextIds(updatedDroppedTextIds);
        setScrollClaimReferencesFoonotes({
          footnotes: updatedFootnotes,
          references: updatedReferences,
          abbreviation: updatedAbbreviation,
        });
      } else {
        setTimeout(() => {
          setDroppedComponentIds(updatedComponentIds);
          setDroppedTextIds(updatedDroppedTextIds);
          setScrollClaimReferencesFoonotes({
            footnotes: updatedFootnotes,
            references: updatedReferences,
            abbreviation: updatedAbbreviation,
          });
        }, 500);
      }
    } else if (selectCompObj.matchTextId && editComponentRef.current) {
      const tempMatchtextsArray = [...refDroppedTextIdsArray.current];
      let footnotes = refScrollClaimReferencesFootnotes.current.footnotes;
      let references = refScrollClaimReferencesFootnotes.current.references;
      let abbreviation = refScrollClaimReferencesFootnotes.current.abbreviation;
      const updatedFootnotes = footnotes.filter(
        (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
      );
      const updatedReferences = references.filter(
        (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
      );
      const updatedAbbreviation = abbreviation.filter(
        (matchText) => matchText.matchTextId !== selectCompObj.matchTextId,
      );
      setDroppedTextIds(
        tempMatchtextsArray.filter(
          (matchTextId) => matchTextId !== selectCompObj.matchTextId,
        ),
      );
      if (event === "Delete") {
        setScrollClaimReferencesFoonotes({
          footnotes: updatedFootnotes,
          references: updatedReferences,
          abbreviation: updatedAbbreviation,
        });
      } else {
        setTimeout(() => {
          setScrollClaimReferencesFoonotes({
            footnotes: updatedFootnotes,
            references: updatedReferences,
            abbreviation: updatedAbbreviation,
          });
        }, 500);
      }
    }
    if (selectCompObj.reusableTextId && editComponentRef.current) {
      const tempRtIdsArray = [...refReusableTextIdsArray.current];
      setReusableTextIdsArray(
        tempRtIdsArray.filter((rtId) => rtId !== selectCompObj.reusableTextId),
      );
    }
    if (selectCompObj.titleId && editComponentRef.current) {
      setDroppedTitleIds((prev) =>
        prev.filter((id) => id !== selectCompObj.titleId),
      );
    }
    const tempLayerData = [...tempLayerScrollbarItems.current];
    let filteredData;
    if (selectCompObj.matchTextId && editComponentRef.current) {
      filteredData = tempLayerData.filter((item) => item.id !== selectCompObj.id);
    } else {
      filteredData = tempLayerData.filter((item) => {
        const itemCompId = item.componentId || item.id;
        const selectedCompId = selectCompObj.componentId || selectCompObj.id;
        return itemCompId !== selectedCompId;
      });
    }
    setScrollbarItems(filteredData);
  };

  const handleDeleteKey = (event) => {
    if (document.querySelector(".hitAreaModalDialog .MuiDialog-container")) {
      return;
    }
    if (editComponentRef.current) {
      if (event.key === "Delete") {
        handleDeleteKeyScrollbarComponent(event.key);
      }
      return;
    }
    if (
      event.target.tagName === "INPUT" ||
      !playPauseRef.current.animationCompleted ||
      event.target.classList.contains("fr-view")
    )
      return;
    var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

    if (mac && event.key === "Backspace") deleteComponentOnCanvas("fromKey");
    else if (event.key === "Delete") {
      deleteComponentOnCanvas("fromKey");
    }
  };

  return {
    deleteComponentOnCanvas,
    handleDeleteKeyScrollbarComponent,
    handleDeleteKey,
  };
};
